const detailedPositionKeys = [
  "tp_detailed_position",
  "tpDetailedPosition",
  "tpDetailedPositions",
  "detailed_positions",
  "detailedPositions",
];

const isDetailedPositionObject = (value) => {
  if (!value || typeof value !== "object") {
    return false;
  }

  return (
    Object.prototype.hasOwnProperty.call(value, "primary_position") ||
    Object.prototype.hasOwnProperty.call(value, "primaryPosition") ||
    Object.prototype.hasOwnProperty.call(value, "secondary_position") ||
    Object.prototype.hasOwnProperty.call(value, "secondaryPosition") ||
    Object.prototype.hasOwnProperty.call(value, "tertiary_position") ||
    Object.prototype.hasOwnProperty.call(value, "tertiaryPosition") ||
    Object.prototype.hasOwnProperty.call(value, "teritory_position")
  );
};

export const extractDetailedPositions = (source) => {
  if (!source || typeof source !== "object") {
    return null;
  }

  if (isDetailedPositionObject(source)) {
    return source;
  }

  for (const key of detailedPositionKeys) {
    if (source[key]) {
      return extractDetailedPositions(source[key]);
    }
  }

  if (source.player) {
    return extractDetailedPositions(source.player);
  }

  return null;
};

const normalizePositionCode = (code) => {
  if (!code || typeof code !== "string") {
    return null;
  }
  return code.trim().toUpperCase();
};

export const formatDetailedPositions = (detailedPositions, fallback) => {
  const fallbackValue = fallback ?? "-";

  if (!detailedPositions || typeof detailedPositions !== "object") {
    return fallbackValue;
  }

  const primary =
    detailedPositions.primary_position || detailedPositions.primaryPosition;
  const secondary =
    detailedPositions.secondary_position || detailedPositions.secondaryPosition;
  const tertiaryCandidate =
    detailedPositions.teritory_position || detailedPositions.tertiary_position || detailedPositions.tertiaryPosition;

  const positions = [primary, secondary, tertiaryCandidate]
    .map(normalizePositionCode)
    .filter(Boolean);

  if (!positions.length) {
    return fallbackValue;
  }

  const uniquePositions = Array.from(new Set(positions));
  return uniquePositions.join(" / ");
};

export const getPositionDisplay = (source, fallback) => {
  const detailedPositions = extractDetailedPositions(source);
  return formatDetailedPositions(detailedPositions, fallback);
};

export const POSITION_HEADER_TOOLTIP = "Primary / Secondary / Tertiary";
export const POSITION_HEADER_SUFFIX = "(P/S/T)";
